// Hook do pobierania szczegółów zadania – GET /sales-crm/tasks/:id

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

/** Odpowiedź API dla pojedynczego zadania (GET /sales-crm/tasks/:id) */
export interface ISalesCrmTask {
  id: number;
  name: string;
  type_formatted: string | null;
  type: string
  icon: {
    type: string;
  };
  client_id: number;
  client: {
    id: number;
    name: string;
    email: string;
  };
  trader_id: number;
  trader: {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    name_formatted: string;
  };
  due_date: string;
  status: number;
  status_formatted: string;
  createdBy?: number;
  createdByUser?: {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    name_formatted: string;
  }
  priority: number;
}

const getSalesCrmTask = (id: number): Promise<ISalesCrmTask> => axios.get(`/sales-crm/tasks/${id}`);

export const useGetSalesCrmTask = (id: number, options?: UseQueryOptions<ISalesCrmTask, IError>) =>
  useQuery<ISalesCrmTask, IError>(['sales-crm', 'tasks', id], () => getSalesCrmTask(id), {
    ...options,
    enabled: options?.enabled !== false && id != null && !Number.isNaN(id)
  });
